var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.304 14.175l4.196.047 9.9 9.9-7.779 7.777-9.9-9.899-.046-4.196 3.63-3.63zm.307 3.936c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersIcon);
export default __webpack_public_path__ + "static/media/offers-icon.72146fb8.svg";
export { ForwardRef as ReactComponent };